import { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { JsdFetchError } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests';
import type { ProjectKey, BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { EDIT_MODE, VIEW_MODE, NEW_MODE } from '../constants';
import type { Mode } from '../types';
import type { ServiceError } from '../types/service.tsx';

export const getSlaPath = (
	baseUrl: BaseUrl,
	projectKey: ProjectKey,
	metricId: string | null = null,
	mode: Mode = VIEW_MODE,
) => {
	let url = `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/sla`;

	if (metricId != null) {
		url += `/custom/${metricId}`;
	}

	if (mode === EDIT_MODE) {
		url += `/${EDIT_MODE}`;
	}

	if (mode === NEW_MODE) {
		url += `/${NEW_MODE}`;
	}

	return url;
};

export const getValidationErrorMessage = (error: ServiceError): string | null => {
	if (error instanceof ValidationError && error.errors.length > 0) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
		const validationError = error.errors[0].error as any;
		return validationError.errorMessage || null;
	}

	if (error instanceof JsdFetchError) {
		return error.message;
	}

	return null;
};
